import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home, Construction } from "lucide-react";

export default function EmergencySetup() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FFF7E6] flex flex-col" data-testid="emergency-setup-screen">
      <div className="max-w-md w-full mx-auto px-6 py-8 flex-1 flex flex-col">
        <button onClick={() => navigate(-1)} data-testid="emergency-back" className="flex items-center gap-1 text-[#111827]/60 font-semibold"><ArrowLeft className="w-5 h-5" /> Back</button>
        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <div className="w-20 h-20 rounded-3xl bg-[#DC2626]/10 flex items-center justify-center mb-6"><Construction className="w-10 h-10 text-[#DC2626]" /></div>
          <h1 className="text-3xl font-bold font-head tracking-tight">Emergency Setup</h1>
          <p className="text-lg text-[#111827]/70 mt-4">Emergency coordination will be activated in Milestone 2.</p>
          <p className="text-sm text-[#111827]/50 mt-3 max-w-sm">HumNest does not replace police, ambulance, fire, or other official emergency services. For real emergencies, dial 112.</p>
          <button onClick={() => navigate("/home")} data-testid="emergency-return-home" className="mt-8 bg-[#F97316] text-white rounded-2xl py-4 px-8 font-bold flex items-center gap-2"><Home className="w-5 h-5" /> Return Home</button>
        </div>
      </div>
    </div>
  );
}
